import { BundleType, selectSharedDataActiveBundleType, useAppSelector } from '@/store';

interface LabelProps {
  text: string;
}

const Label = ({ text }: LabelProps) => {
  return <span className="text-[20px] font-semibold whitespace-nowrap">{text}</span>;
};

export const BundleLabel = () => {
  const activeBundleType = useAppSelector(selectSharedDataActiveBundleType);

  return (
    <>
      {activeBundleType === BundleType.FULL && <Label text="Full Bundle" />}
      {activeBundleType === BundleType.LIGHT && <Label text="Light Bundle" />}
    </>
  );
};
